import { Typography } from '@mui/joy';
import { Warning } from '@phosphor-icons/react';
import { FormattedMessage } from 'react-intl';

import { Alert } from '~/components/ui/alert';
import QueryResolver from '~/services/api/query-resolver';
import { UtilityService } from '~/services/api/utilities/endpoints';

export default function DecryptionResolver({
  content,
  children,
  loadingElement,
  strategy = 'default',
}: Readonly<{
  content: string;
  children: (decryptedText: string) => React.ReactNode;
  strategy?: 'stale-while-revalidate' | 'default';
  loadingElement?: React.ReactNode;
}>) {
  const query = UtilityService.endpoints.decryptText.useQuery({ content });

  if (!content) {
    return (
      <Alert color='neutral' startDecorator={<Warning weight='fill' />}>
        <Typography>
          <FormattedMessage defaultMessage='No Content to decrypt' />
        </Typography>
      </Alert>
    );
  }

  return (
    <QueryResolver
      query={query}
      strategy={strategy}
      loadingElement={loadingElement}
    >
      {(decryptedContent) => children(decryptedContent)}
    </QueryResolver>
  );
}
